import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
class Disclaimer extends Component {
    render() { 
        return (
            <p {...this.props}>
                { this.props.disclaimer }
            </p>
        )
    }
}

Disclaimer.propTypes = {
    disclaimer: PropTypes.string.isRequired
}

export default connect(({ disclaimer }) => ({ disclaimer }))(Disclaimer);


// WEBPACK FOOTER //
// ./src/components/Disclaimer.js